
export interface Deferred<T> {
  promise: Promise<T>
  /* eslint-disable-next-line no-unused-vars */
  resolve: (value: T | PromiseLike<T>) => void
  /* eslint-disable-next-line no-unused-vars */
  reject: (reason?: any) => void
  isResolved: boolean
  isRejected: boolean
  isPending: boolean
}

export function createDeferred<T> (): Deferred<T> {
  let externalResolve, externalReject
  let isResolved = false
  let isRejected = false
  let isPending = true
  const promise = new Promise<T>((resolve, reject) => {
    externalResolve = resolve
    externalReject = reject
  })
  promise
    .then(() => {
      isResolved = true
      isPending = false
    })
    .catch(() => {
      isRejected = true
      isPending = false
    })
  return {
    promise,
    resolve: externalResolve!,
    reject: externalReject!,
    get isResolved () {
      return isResolved
    },
    get isRejected () {
      return isRejected
    },
    get isPending () {
      return isPending
    }
  }
}
